import MainButton from '@/components/ui/custom/buttons/MainButton';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import ProjectSectionHeader, {
  ProjectSectionHeaderProps,
} from './ProjectSectionHeader';

export default function ProjectSectionHeaderPage({
  className,
  ...props
}: Omit<ProjectSectionHeaderProps, 'button'>) {
  const { t: tCarousel } = useTranslation('translation', {
    keyPrefix: 'projects.carousel',
  });
  const navigate = useNavigate();

  return (
    <div className="w-full py-5 sticky top-0 bg-base-200 z-10">
      <div className="absolute right-full top-0 w-5 h-full bg-base-200"></div>

      <ProjectSectionHeader
        {...props}
        className={{
          title: twMerge(
            'font-600 text-20 text-accent font-poppins',
            className?.title,
          ),
        }}
        button={
          <MainButton
            text={tCarousel('back')}
            onClick={() => {
              navigate('..');
            }}
            color="custom"
            className="font-600 !text-14 text-primary gap-1"
            icon={
              <ChevronLeftIcon className="w-4 h-4 ease-in-out transition-all duration-200" />
            }
          />
        }
      />
      <div className="absolute left-full top-0 w-5 h-full bg-base-200"></div>
    </div>
  );
}
